// Import uniwersalnego wrappera do komunikacji z API (obsługuje GET/POST/DELETE itd.)
import { fetchWrapper } from "@/helpers/fetch-wrapper";

// Klasa obsługująca operacje na czarnej liście pojazdów (Black List)
class BlackListsService {

    /**
     * Dodaje nowy numer rejestracyjny do czarnej listy (Black List).
     * @param {string} licensePlate - Numer rejestracyjny pojazdu.
     * @param {string} description - Opis pojazdu.
     * @param {number|null} userId - ID przypisanego użytkownika (opcjonalnie).
     * @param {string|null} validFrom - Data od (YYYY-MM-DD) (opcjonalnie).
     * @param {string|null} validTo - Data do (YYYY-MM-DD) (opcjonalnie).
     * @returns odpowiedź z API lub undefined jeśli brak wymaganych danych.
     */
    async postNewPlate(licensePlate, description, userId, validFrom = null, validTo = null) {
        // Walidacja - nie wysyłaj zapytania jeśli brakuje tablicy lub opisu.
        if (!licensePlate || !description) {
            return;
        }

        // Normalizacja pustych stringów na null
        const from = validFrom && String(validFrom).trim() !== '' ? String(validFrom).trim() : null;
        const to   = validTo && String(validTo).trim() !== '' ? String(validTo).trim() : null;

        // Walidacja zakresu dat (jeśli podane)
        // Zakładamy format YYYY-MM-DD z input type="date"
        if ((from && !to) || (!from && to)) {
            throw new Error('Both validFrom and validTo must be provided together.');
        }
        if (from && to && from > to) {
            throw new Error('validFrom cannot be later than validTo.');
        }

        // Body requestu
        const body = {
            plateLpr: licensePlate,
            typeOfList: 0, // 0 = czarna lista
            description: description,
            userId: userId ?? null,
            ...(from && to ? { validFrom: from, validTo: to } : {})
        };

        // Wywołanie endpointu POST do /wanted-plates – zapisanie pojazdu na czarnej liście
        return await fetchWrapper.post(
            process.env.VUE_APP_API_URL + '/wanted-plates',
            body
        );
    }

    /**
     * Pobiera listę wszystkich użytkowników (np. do przypisania pojazdu).
     * Limit 1000 użytkowników na jedną stronę.
     */
    async getUsers() {
        return fetchWrapper.get(`${process.env.VUE_APP_API_URL}/users?page=1&limit=1000`);
    }

    /**
     * Pobiera wszystkie pojazdy z czarnej listy (paginacja po 10, sortowanie malejąco).
     */
    async getAll() {
        try {
            // UWAGA: URLSearchParams + tablica bywa różnie serializowana.
            // Jeśli backend oczekuje "typesOfLists=0" (bez []), to ten zapis jest bezpieczniejszy:
            const params = new URLSearchParams();
            params.append('typesOfLists', '0');
            params.set('orderDirection', 'desc');
            params.set('page', '1');
            params.set('limit', '10');

            const response = await fetchWrapper.get(
                `${process.env.VUE_APP_API_URL}/wanted-plates?${params.toString()}`
            );

            return response;
        } catch (error) {
            console.error('Error fetching vehicles:', error);
        }
    }

    /**
     * Usuwa pojazd z czarnej listy po ID.
     * @param {number} id - ID pojazdu.
     */
    async delete(id) {
        try {
            return await fetchWrapper.delete(
                `${process.env.VUE_APP_API_URL}/wanted-plates/${id}`
            );
        } catch (error) {
            console.error('Error deleting vehicle:', error);
        }
    }
}

// Eksport instancji serwisu do użycia w komponentach
export default new BlackListsService();
